import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentRedaction } from 'store/AdminClient/RedactionData';
import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';
import axiosPrivate from 'config/axiosPrivate';

export const useAdminClientPutToDraft = ({
  t,
  actualHtmlContent,
  actualTextContent,
  initialHtmlContent,
  initialTextContent,
  keyword,
  metaDescriptionTag,
  list,
  combinedKeywords,
  websites,
  stuffedKeywords,
  initialStuffedKeywords,
  possibleStuffedKeywords,
  textTitle,
  titleTag,
  url,
  textId,
  projectId,
  writerProjectId,
  type,
  activeInitialText,
  totalNumberOfTextAdded,
  actualTextWordCount,
  initialTextWordCount,
  contentScore,
  websiteId,
  aiAgentId,
  currentSemanticGap,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setErrorSuccess,
}) => {
  const dispatch = useDispatch();

  const putToDraft = useCallback(async (demande, finalHtmlContent) => {
    try {
 
      const validTypes = ['NON_TRANSLATED', 'COMBINED', 'TRANSLATED'];
      const documentType = type && validTypes.includes(type) ? type : 'NON_TRANSLATED';
      
      let response;
      
      if (textId) {
        const dataForPut = {
          keyword: keyword || '',
          url: url || '',
          titleTag: titleTag || '',
          metaDescriptionTag: metaDescriptionTag || '',
          contentScore: contentScore || NaN,
          actualTextContent: actualTextContent || '',
          initialTextContent: initialTextContent || '',
          actualHtmlContent: finalHtmlContent || actualHtmlContent || '',
          initialHtmlContent: initialHtmlContent || '',
          activeInitialText: activeInitialText !== undefined ? activeInitialText : true,
          numberWords: actualTextWordCount || 0,
          type: documentType,
          semanticGap: currentSemanticGap || (list ? transformToSemanticGap(combinedKeywords) : []),
          internalLinking: websites || '',
          aiAgentId: aiAgentId || '',
        };
        console.log('🔍 PUT /texts/external/{id}:', dataForPut);
        
        response = await axiosPrivate.put(
          `/texts/external/${textId}`,
          dataForPut
        );
      } else {
        // POST - Création d'un nouveau texte
        const dataForPost = {
          keyword: keyword || '',
          url: url || '',
          titleTag: titleTag || '',
          metaDescriptionTag: metaDescriptionTag || '',
          contentScore: contentScore || null,
          actualTextContent: actualTextContent || '',
          initialTextContent: initialTextContent || '',
          actualHtmlContent: finalHtmlContent || actualHtmlContent || '',
          initialHtmlContent: initialHtmlContent || '',
          activeInitialText: activeInitialText !== undefined ? activeInitialText : true,
          type: documentType,
          numberWords: actualTextWordCount || 0,
          writerProjectId: writerProjectId || 0,
          semanticGap: currentSemanticGap || (list ? transformToSemanticGap(combinedKeywords) : []),
          internalLinking: websites || '',
          aiAgentId: aiAgentId || '',
          websiteId: websiteId || 0,
        };
        console.log('🔍 POST /texts/external/', dataForPost);
        
        response = await axiosPrivate.post(
          `/texts/external/`,
          dataForPost
        );
      }

      const result = response.data || {};

    
      dispatch(
        setCurrentRedaction({
          id: result.id || projectId,
          title: result.textTitle || textTitle || keyword || '',
          textTitle: result.textTitle || textTitle || keyword || '',
          keyword: result.keyword || keyword || '',
          url: result.url || url || '',
          titleTag: result.titleTag || titleTag || '',
          metaDescriptionTag: result.metaDescriptionTag || metaDescriptionTag || '',
          initialHtmlContent: result.initialHtmlContent || initialHtmlContent || null,
          initialTextContent: result.initialTextContent || initialTextContent || null,
          actualHtmlContent: result.actualHtmlContent || finalHtmlContent || actualHtmlContent || null,
          actualTextContent: result.actualTextContent || actualTextContent || null,
          type: result.type || type || null,
          semanticGap: result.semanticGap || [],
          stuffedKeywords: stuffedKeywords || [],
          initialStuffedKeywords: initialStuffedKeywords || [],
          possibleStuffedKeywords: possibleStuffedKeywords || [],
          internalLinking: result.internalLinking || websites || null,
          delivered: !!result.delivered,
          revisionSent: !!result.revisionSent,
          revisionDone: !!result.revisionDone,
          globalRevisionSent: !!result.globalRevisionSent,
          validated: !!result.validated,
          edited: !!result.edited,
          deployed: !!result.deployed,
          verifiedByAdmin: !!result.verifiedByAdmin,
          orderId: result.projectId || projectId || null,
          writerProjectId: result.writerProjectId || writerProjectId || null,
          projectId: result.projectId || projectId || null,
          websiteId: result.websiteId || null,
          maxWords: result.maxWords || 0,
          minWords: result.minWords || 0,
       
          totalNumberOfTextAdded: result.totalNumberOfTextAdded || totalNumberOfTextAdded || 0,
          activeInitialText: result.activeInitialText !== undefined ? result.activeInitialText : activeInitialText,
          createdAt: result.createdAt || new Date().toISOString(),
          deliveredAt: result.deliveredAt || null,
          revisionRequestAt: result.revisionRequestAt || null,
          globalRevisionRequestAt: result.globalRevisionRequestAt || null,
          revisionDoneAt: result.revisionDoneAt || null,
          validateAt: result.validateAt || null,
          revisionText: result.revisionText || null,
          revisionFileName: result.revisionFileName || null,
       
          initialScoreData: result.contentScore || contentScore || null,
        })
      );

      setErrorSuccessMsg(
        `${t('Le texte')} ${textTitle} ${t('a été mis en brouillon')}!`
      );
      setErrorSuccessImg('/Images/succes.png');
      setIsSuccess(true);
      setErrorSuccess(true);

      return result;
    } catch (error) {
      console.error('🔍 AdminClient putToDraft error:', error);
      
   
      const errorMessage = error.response?.data?.message 
        || error.message 
        || t("Oups....! Une erreur s'est produite");
      
      setErrorSuccessMsg(errorMessage);
      setIsSuccess(false);
      setErrorSuccess(true);
      
      throw error; 
    }
  }, [
    actualHtmlContent,
    actualTextContent,
    initialHtmlContent,
    initialTextContent,
    keyword,
    metaDescriptionTag,
    list,
    combinedKeywords,
    websites,
    stuffedKeywords,
    initialStuffedKeywords,
    possibleStuffedKeywords,
    textTitle,
    titleTag,
    url,
    textId,
    projectId,
    writerProjectId,
    type,
    activeInitialText,
    totalNumberOfTextAdded,
    actualTextWordCount,
    initialTextWordCount,
    contentScore,
    websiteId,
    aiAgentId,
    currentSemanticGap,
    setErrorSuccessMsg,
    setErrorSuccessImg,
    setIsSuccess,
    setErrorSuccess,
    dispatch,
    t,
  ]);

  return { putToDraft };
};